import { bootstrapApplication } from '@angular/platform-browser';
import {
  PreloadAllModules,
  RouteReuseStrategy,
  provideRouter,
  withPreloading,
} from '@angular/router';
import {
  IonicRouteStrategy,
  provideIonicAngular,
} from '@ionic/angular/standalone';

import { IonicModule } from '@ionic/angular';

import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { APP_INITIALIZER, importProvidersFrom, inject } from '@angular/core';
import { JwtModule } from '@auth0/angular-jwt';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { CoreModule } from './app/core/core.module';
import { HttpInterceptor } from './app/core/interceptor/httpinterceptor.service';
import { CustomPipeModule } from './app/core/pipes/pipe.module';
import { IconService } from './app/core/services/icon.service';
import { CustomIonModule } from './app/custom-ion-module/custom-ion-module.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { AppThemeService } from './app/core/services/apptheme.service';
import { provideAnimations } from '@angular/platform-browser/animations';

export function initializeApp(iconService: IconService): () => Promise<void> {
  return () => iconService.initIcons();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptors([HttpInterceptor])),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [IconService, AppThemeService],
      multi: true,
    },

    importProvidersFrom([
      CustomIonModule,
      CoreModule,
      IonicModule,
      CustomPipeModule,
      JwtModule.forRoot({
        config: {},
      }),
      NgIdleKeepaliveModule.forRoot(),
    ]),
  ],
});
